export default __webpack_public_path__ + "static/media/hero-projects.d8dd6313.svg";